import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const putawayKpis /*: WarehouseKPI[] */ = [
  {
    id: 'putaway_cycle_time',
    processType: ActivityEventProcessType.PUTAWAY,
    category: 'process',
    title: 'Put-away Cycle Time (Dock-to-stock time)',
    description:
      'Average time from receipt to storage location assignment completion',
    unit: 'min',
    formula: 'AVG(TIMEDIFF(storage_timestamp, receiving_timestamp)) / 60',
    tags: ['put_away', 'time_and_motion', 'efficiency'],
    benchmark: {
      standards: {
        site: {
          target: 20,
          warning: { upper: 30 },
          critical: { upper: 45 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 20 },
            { label: 'Warning', min: 20.01, max: 30 },
            { label: 'Target', min: 30.01, max: 45 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['item_size', 'storage_zone', 'shift'],
    alertTopic: 'warehouse.alerts.process.putaway_time',
  },
  {
    id: 'putaway_rate',
    processType: ActivityEventProcessType.PUTAWAY,
    category: 'process',
    title: 'Putaway Rate',
    description: 'Number of items put away per hour',
    unit: 'items/hr',
    formula: 'COUNT(items_put_away) / SUM(hours_worked)',
    tags: ['putaway', 'rate'],
    benchmark: {
      standards: {
        site: {
          target: 100,
          warning: { lower: 80 },
          critical: { lower: 60 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 60 },
            { label: 'Warning', min: 60.01, max: 80 },
            { label: 'Target', min: 80.01, max: 100 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['zone', 'shift'],
    alertTopic: 'warehouse.alerts.process.putaway_rate',
  },
  // TODO: Dwell time -  dwell time between when a shipment arrives at the warehouse and when it’s processed.
];

export default putawayKpis;
